
<template>
  <div class="auth-modal">
    <div class="modal-content">
        <h2>Login or create an account to access those features.</h2>
        <button class="close-button" @click="close">✕</button>
        <div class="login-sign-up">
            <p>Login or Sign-Up with a social account</p>
            <div class="google-button" @click="loginWithGoogle">
                <img src="https://fonts.gstatic.com/s/i/productlogos/googleg/v6/24px.svg" alt="Google Logo">
                <span>Continue with Google</span>
            </div>
            <p>Or</p>
        </div>
    </div>
  </div> 
</template>

<script>
import { signInWithGoogle, logout } from '../auth';

export default {
  name: 'AuthModal',
  methods: {
    close() {
      this.$emit('close');
    },
    async loginWithGoogle() {
      console.log("Start logging in with google")
      let user;
      try {          
          user = await signInWithGoogle();
          console.log('Firebase Auth Result:', user);          
          if(user){
            this.$emit('login-success', user);
          } else {
            this.$emit('login-error');
          }
      } catch (error) {
        console.error("Error during sign in", error);
        this.$emit('login-error');
      }
    },
    async logout() {
      try{
        await logout()
      } catch (error) {
        console.error('Error during sign out', error);
        this.$emit('login-error');
      }
    }
  }
};
</script>

<style scoped>
.auth-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-content {
    background-color: #111;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 0 20px rgba(30, 30, 30, 0.5);
    width: 80%;
    max-width: 500px; /* Add a max-width */
    color: white;
    text-align: center;
    position: relative; /* Required for absolute positioning of close button */
}



.google-button {
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
    padding: 15px 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.google-button img {
  margin-right: 10px;
}

.google-button span {
  color: #757575;
}

.google-button:hover {
  background-color: #f0f0f0;
}

.login-sign-up {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.modal-content h2 {
    margin-bottom: 20px;
}

.login-sign-up p {
    font-size: 1.1em;
    margin-bottom: 20px;
}

.close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  color: white;
  font-size: 30px;
  cursor: pointer;
  z-index: 1002;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.close-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Mobile-First Design */
@media (max-width: 600px) {
    .modal-content {
        width: 95%;
        padding: 15px;
    }
    
    .close-button {
        top: 10px;
        right: 10px;
        font-size: 24px;
        width: 35px;
        height: 35px;
    }
}

</style>